export const environment = {
  
  production: true,
  
  baseUrl: (<any>window).baseApi,

  taxiUrl: (<any>window).taxiApi,

  baseUrlHub: (<any>window).baseApiHub,
  
  encryptionKey: 'sNMELyC8ohN8WF_WRnalirezajbHMItOVizcscPiWsQJX9hmw'

};
